import Card from '../../../components/ui/Card';

/**
 * Site information card for the site details page. Display-only.
 */
export default function SiteDetailsInfoCard({
  siteCode,
  addressLine,
  addressMapsUrl,
  nextDue,
  statusLabel,
  statusClass,
}) {
  return (
    <Card style={{ marginBottom: '1.5rem' }}>
      <h3 className="card-title">Site information</h3>
      <p><strong>Site ID:</strong> {siteCode}</p>
      <p>
        <strong>Address:</strong>{' '}
        {addressMapsUrl ? (
          <a href={addressMapsUrl} target="_blank" rel="noopener noreferrer" className="site-details-address-link">
            {addressLine}
          </a>
        ) : (
          addressLine
        )}
      </p>
      <p><strong>Next Inspection Due:</strong> {nextDue}</p>
      <p><strong>Status:</strong> <span className={statusClass}>{statusLabel}</span></p>
    </Card>
  );
}
